import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const ACCEPT_OVERRIDES_REQUEST = 'ACCEPT_OVERRIDES_REQUEST';
export const ACCEPT_OVERRIDES_SUCCESS = 'ACCEPT_OVERRIDES_SUCCESS';
export const ACCEPT_OVERRIDES_FAILURE = 'ACCEPT_OVERRIDES_FAILURE';

function request() {
  return {
    type: ACCEPT_OVERRIDES_REQUEST,
    isSavingValidationOverrides: true,
  };
}

function receive(validationResult) {
  return {
    type: ACCEPT_OVERRIDES_SUCCESS,
    isSavingValidationOverrides: false,
    validationResult,
    validationOverridesError: null
  };
}

function reject(validationOverridesError) {
  return {
    type: ACCEPT_OVERRIDES_FAILURE,
    isSavingValidationOverrides: false,
    validationOverridesError
  };
}

export function acceptValidationOverrides(formId, data) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .acceptValidationOverrides(formId, data)
      .then((response) => {
        dispatch(receive(response.data));
        toastr.success('Success', 'Your validation overrides have been accepted.');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
